module.exports = __webpack_public_path__ + "static/11-9a35157e0609fb3d787bd7c85c47c3bd.jpg";